import { render } from "./failureRate.vue?vue&type=template&id=225de8b2&scoped=true"
import script from "./failureRate.vue?vue&type=script&lang=js"
export * from "./failureRate.vue?vue&type=script&lang=js"

import "./failureRate.vue?vue&type=style&index=0&id=225de8b2&lang=less&scoped=true"

import exportComponent from "D:\\work\\ask_cloud\\QC\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-225de8b2"]])

export default __exports__